import { isEmpty } from "lodash"

export function isGroupRow(contributor: { children?: unknown }): boolean {
  return !isEmpty(contributor.children)
}
